import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { cloneDeep } from 'lodash'
// Import the action creators
import * as Actions from './actions'

export const getListTrainingCategory = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { trainingCategoryList: { resultTable: { appliedFilter } } } = getState()
    let updateSortModel = dispatch(convertToSearchModel(appliedFilter));

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateTrainingCategoryList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

// TRAINING CATEGORY LIST ACTIONS/ACTION OPERATIONS
export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(1))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListTrainingCategory())
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListTrainingCategory())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { trainingCategoryList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListTrainingCategory())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListTrainingCategory())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListTrainingCategory())
}

// TRAINING CATEGORY ADD ACTION OPERATIONS
export const createTrainingCategory = (data) => (dispatch, getState) => {
    const { trainingCategoryList: { alertCreate } } = getState()
    let nAlert = { ...alertCreate }
    dispatch(Actions.showLoading(true))
    
    return ApiService.post(Path.ROOT, data)
        .then((response) => {
            if (response) {

                let title = 'Create Success'
                const { message } = response.data
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed'
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                    onHide: () => {
                        dispatch(Actions.hideAddAlert())
                    }
                }
                dispatch(getListTrainingCategory());
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

// TRAINING CATEGORY DETAIL/UPDATE ACTION OPERATIONS
export const getTrainingCategoryById = (id, mode) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.ROOT + '/' + id)
        .then((response) => {
            dispatch(Actions.setTrainingCategoryDetail(response.data, mode))
            return response.data;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const updateTrainingCategory = (ID) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    const { trainingCategoryList: { updateValues } } = getState()
    const { auth } = getState()
    let userId = auth.credentials.userId
    let companyId = auth.credentials.companyId

    let updatedData = cloneDeep(updateValues);
    updatedData.UserID = userId;
    updatedData.companyID = companyId;
    updatedData.ID = ID;

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + ID, updatedData)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const { message } = response.data
                let goBackToList = true
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Training Category successfully updated.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                    onHide: () => {
                        dispatch(Actions.hideListAlert())
                        dispatch(resetSearchResults())
                    }
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
            dispatch(Actions.setListAlert(returnValue.alertData))
        })
}   

export const deleteTrainingCategory = (data) => (dispatch) => {
    dispatch(Actions.isLoading(true))

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'Training Category successfully deleted.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.delete(Path.ROOT + '/' + data)
        .then((response) => {
            if (response) {
                let title = 'Delete Success'
                const { message } = response.data
                if (response.data.returnCode <= 0) {
                    title = 'Delete Failed'
                }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const convertToSearchModel = (data) => (dispatch, getState) =>{ 
    const { auth } = getState()
    let userId = auth.credentials.userId
    let companyId = auth.credentials.companyId
    return {
        ...data,
        UserID: userId,
        CompID: companyId,
        Pagination: {
            Page: (data.Pagination.Page - 1 < 0) ? 0 : data.Pagination.Page - 1,
            PageSize: data.Pagination.PageSize,
        },
    }
}





